/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Status_DraftInputs */

const en_admin_posts_status_draft = /** @type {(inputs: Admin_Posts_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const zh_admin_posts_status_draft = /** @type {(inputs: Admin_Posts_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Admin_Posts_Status_DraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_status_draft = /** @type {((inputs?: Admin_Posts_Status_DraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Status_DraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_status_draft(inputs)
	return zh_admin_posts_status_draft(inputs)
});
export { admin_posts_status_draft as "admin.posts.status_draft" }